import React, { useEffect } from 'react';

export interface ActionSheetAction {
  label: string;
  style?: 'default' | 'destructive' | 'cancel';
  onClick?: () => void;
}

interface ActionSheetProps {
  open: boolean;
  title?: string;
  message?: string;
  actions: ActionSheetAction[];
  onClose: () => void;
}

const ActionSheet: React.FC<ActionSheetProps> = ({ open, title, message, actions, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const mainActions = actions.filter((a) => a.style !== 'cancel');
  const cancelAction = actions.find((a) => a.style === 'cancel');

  return (
    <>
      <div className="sheet-backdrop" onClick={onClose} />
      <div className="action-sheet" role="dialog" aria-modal="true">
        <div className="action-sheet-group">
          {(title || message) && (
            <div className="action-sheet-title">
              {title && <div style={{ fontWeight: 600, color: 'var(--ios-label)', marginBottom: message ? 4 : 0 }}>{title}</div>}
              {message && <div>{message}</div>}
            </div>
          )}
          {mainActions.map((a, i) => (
            <button
              key={i}
              className={`action-sheet-btn ${a.style === 'destructive' ? 'destructive' : 'default'}`}
              onClick={() => {
                a.onClick?.();
                onClose();
              }}
            >
              {a.label}
            </button>
          ))}
        </div>
        <button
          className="action-sheet-cancel"
          onClick={() => {
            cancelAction?.onClick?.();
            onClose();
          }}
        >
          {cancelAction?.label ?? 'Abbrechen'}
        </button>
      </div>
    </>
  );
};

export default ActionSheet;
